import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MobileDataService {
  public insets: any;
  public allGamesArray: any;
  public keyWordList: any;
  public mobileBottomKeyWordList: [] = null;
  public mobileTopKeywordList: [] = null;
  public rgLogoSrc: string = "";

  public defaultKeyword = {
    topKeyword: null,
    bottomKeyword: "Home",
  };
  _mobileLobbyKeyword: BehaviorSubject<any> = new BehaviorSubject(
    this.defaultKeyword
  );
  private _mobileCasinoDeeplink: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() {}

  setLobbiesList(casinoLobbies) {
    if (casinoLobbies) {
      let mainLobbies = casinoLobbies.filter((l) => l.placement === "MAIN");
      let bottomLobbies = casinoLobbies.filter((l) => l.placement === "BOTTOM");

      if (bottomLobbies.length > 0)
        this.setBottomKeywordList(bottomLobbies[0].keywordInfo);
      if (mainLobbies.length > 0)
        this.setTopKeywordList(mainLobbies[0].keywordInfo);
    }
  }

  getBottomKeywordList() {
    return this.mobileBottomKeyWordList;
  }

  getTopKeywordList() {
    return this.mobileTopKeywordList;
  }

  setBottomKeywordList(keyWordList) {
    this.mobileBottomKeyWordList = keyWordList;
  }

  setTopKeywordList(keyWordList) {
    this.mobileTopKeywordList = keyWordList;
  }

  setMobileLobbyKeyword(SelectedKeyword) {
    this._mobileLobbyKeyword.next(SelectedKeyword);
  }
  getMobileLobbyKeyword() {
    return this._mobileLobbyKeyword;
  }

  sendExternalSelection(selection) {
    this.setMobileLobbyKeyword({
      topKeyword: null,
      bottomKeyword: selection,
    });
  }

  setMobileCasinoDeeplink(deeplinkValue) {
    this._mobileCasinoDeeplink.next(deeplinkValue);
  }
  getMobileCasinoDeeplink() {
    return this._mobileCasinoDeeplink;
  }

  setRgLogoSrc(rgLogoSrc) {
    this.rgLogoSrc = rgLogoSrc;
  }

  getRgLogoSrc() {
    return this.rgLogoSrc;
  }
}
